import { merge } from 'lodash-es'
import { logger } from './logger'

export function loadSettingsFromJson<T extends { byJsonElement?: string }> (settings: T): T {
  if (settings.byJsonElement == null) return settings
  logger.debug('Loading settings from JSON element: ' + settings.byJsonElement)
  const scriptEl = document.querySelector(settings.byJsonElement)
  if (scriptEl == null) { throw new Error('No script element found: ' + settings.byJsonElement) }
  if (scriptEl?.getAttribute('type') !== 'application/json') throw new Error('Invalid script element type. Must have `type="application/json"`: ' + settings.byJsonElement)
  if (scriptEl == null) { throw new Error('No script element found: ' + settings.byJsonElement) }
  const json = scriptEl.textContent
  if (json == null) { throw new Error('No JSON found in script element: ' + settings.byJsonElement) }
  const mergedSettings = merge({}, settings, JSON.parse(json))
  return mergedSettings as T
}
